import React from 'react';
import PropTypes from 'prop-types';
import { FeatureProvider } from './context';

export default function FeatureSelectorProviderWrapper(props) {
    const { categories, features } = props;
    return (
        <FeatureProvider
            value={{
                categories,
                featuresData: features,
            }}
        >
            {props.children}
        </FeatureProvider>
    );
}

FeatureSelectorProviderWrapper.propTypes = {
    children: PropTypes.ReactChildren,
    categories: PropTypes.arrayOf(PropTypes.string),
    features: PropTypes.object,
};
